"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/** When your routing table is too long, you can split it into small modules **/
var dentalRouter = {
  path: '/dental',
  component: _layout.default,
  redirect: '/dental/clinic/list',
  name: 'dental',
  meta: {
    title: '华西口腔管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'clinic',
    name: 'clinic',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/dental'));
      });
    },
    meta: {
      title: '诊所管理',
      icon: 'clipboard'
    },
    children: [{
      path: 'list',
      name: 'clinicList',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/dental/clinic/list'));
        });
      },
      meta: {
        title: '诊所列表',
        icon: 'clipboard'
      }
    }]
  }, {
    path: 'product',
    name: 'product',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/dental'));
      });
    },
    meta: {
      title: '套餐商品管理',
      icon: 'shopping'
    },
    children: [{
      path: 'list',
      name: 'productList',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/dental/product'));
        });
      },
      meta: {
        title: '套餐商品列表',
        icon: 'list'
      }
    }, {
      path: 'detail',
      name: 'productDetail',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/dental/product/detail'));
        });
      },
      meta: {
        title: '商品详情',
        icon: 'eye',
        activeMenu: '/dental/product/list'
      },
      hidden: true
    }]
  }, {
    path: 'order/list',
    name: 'DentalOrderList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/dental/order/list'));
      });
    },
    meta: {
      title: '订单管理',
      icon: 'shopping-cart'
    }
  }]
};
var _default = exports.default = dentalRouter;